<template lang="pug">
v-app#cepi
    v-navigation-drawer(v-model='drawer', app='')
        v-list(dense='')
            template(v-for='item in menu')
                template(v-if='item.submenu')
                    v-list-group(value='true')
                        template(v-slot:activator='')
                            v-list-item-title.menu_p {{ item.text }}
                        v-list-item.submenu-on(v-for='(subitem, i) in item.submenu' :key='i' link='')
                            v-list-item-content(@click='nav(subitem.route)')
                                v-list-item-title {{ subitem.text }}
                template(v-else)
                    v-list-item( link )
                        v-list-item-content(@click='nav(item.route)')
                            v-list-item-title.menu_p {{item.text}}
        v-container
            HelloWorld




    v-app-bar(app='', color='indigo', dark='')
        v-app-bar-nav-icon(@click.stop='drawer = !drawer')
        v-toolbar-title CEPI - Test {{ user }}
        v-content.logout-st
            | Logout 
            v-icon.logout(@click='logout()')
        
    v-content
        v-container
            v-banner.notify-banner(v-if='exams_notify.length > 0' :sticky='true' :single-line='true' :color='color')
                | {{ notify_msg }}

                template(v-slot:actions='' v-if='unique_exam' )
                    v-btn( text='' color='white' @click='goToExam(true)')
                        | Ir al Examen
                template(v-slot:actions='' v-else-if='noProfile' )
                    v-btn.goBtn( text='' color='white' @click='goToExam(false)')
                        | Ir al mi perfil



            slot
    v-footer(color='indigo', app='')
        span.white--text © 2019
    
</template>

<script>

  import { config } from '../config.js'
  import HelloWorld from '../components/HelloWorld';

  export default {
    props: {
      source: String,
    },
    components: {
        HelloWorld,
    },
    data: () => ({
      noProfile: true,
      drawer: null,
      unique_exam: true,
      vary: false,
      color: '#1CC5CB',
      menu: [],
      notify_msg: '',
      user: '',
      exams_notify: []
    }),
    created(){
        var user =  JSON.parse(localStorage.getItem('user'));
        if(user){
            this.user = user.admin ? ` - - Usuario : ${user.name} - Administrador` : ` Usuario : ${user.email} `;
        }
        
        if(user){
            if(user.admin){
                this.menu = [
                    { text: 'Profile', route:'profile' },
                    { text: 'Manage', route:'', submenu: [
                        { text: 'Users', route:'usersadmin' },
                        { text: 'Create Users', route:'manageUsers' },
                        { text: 'Levels', route:'levels' },
                        { text: 'Categories', route:'categories' },
                        { text: 'Subcategories', route:'subcategories' },
                        { text: 'Questions', route:'questions' },
                        { text: 'Persons- Info', route:'students' },
                        { text: 'Groups', route:'groups' },
                        { text: 'Exams', route:'exams' }
                    ] },
                    { text: 'Reports', route:'global-results' }

                ]
            }else if(user.inst || user.type == 'Profesor'){
                this.menu = [
                    { text: 'Profile', route:'profile' },
                    { text: 'Reports', route:'global-results' }
                ]
            }else{
                this.menu = [
                    { text: 'Profile', route:'profile' }
                ]
            }
        }
        this.checkPendindgs();
    },
    methods: {
        nav(route){
            this.$router.push({ name: route })
        },
        goToExam(unique){
            if(unique){
                this.$router.push({ name: 'lanTest' , query : { id: this.exams_notify[0] }});
            }else{
                this.$router.push({ name: 'profile' });
            }
        },
        checkPendindgs(){
            var user =  JSON.parse(localStorage.getItem('user'));
            let _this = this;
            

            this.axios.get(`${config.serviceUri}exams?idRelated=${user.id}`)
                .then( (response) => {
                    console.log('Succes Auth Exams: ',response.data);
                    _this.exams_notify = response.data.payload.exams;
                    
                    if(_this.exams_notify.length > 0){
                        if(_this.exams_notify.length == 1){
                            _this.unique_exam = true;
                            _this.noProfile = true;
                            _this.notify_msg = `Hay un examen pendiente por realizar. De click en el botón para poder realizarlo.`;
                        }else if(this.$router.currentRoute.name == 'profile'){
                            _this.unique_exam = false;
                            _this.noProfile = false;
                            _this.notify_msg = `Hay ${_this.exams_notify.length} examenes pendientes por realizar. Ve a la sección de Exámenes Disponibles para realizarlos.`;
                        }else{
                            _this.unique_exam = false;
                            _this.noProfile = true;
                            _this.notify_msg = `Hay ${_this.exams_notify.length} examenes pendientes por realizar, ve a la opción "Profile" para realizar el examen`;
                        }
                    }
                })
                .catch( (error) => {
                    console.log('Error: ', error);
                    this.$emit("loadingEvent", false);
                });
        },
        logout(){
            this.$router.push({ name: 'login' })
            localStorage.clear();
        }
    }
  }
</script>

<style>
.menu_p{
    font-size: 1rem !important;
}

.submenu-on{
    background: rgb(100, 112, 149, 0.2);
    color: white;
}
.logout-st{
    float: right !important;
    right: 0 !important;
    text-align: right;
    padding: 0 !important;
}
.notify-banner{
    background: #378CE0 !important;
    color: #ffffff !important;
}

.goBtn{
    background: #84B9EE !important;
}
</style>
